<!--
  The grid's quick-create popover in the skin (Johanna, 2026-10-21): the title takes the cursor; Reminder on a line of
  its own; Repeat and Calendar side by side and Meeting link, each named above its field; participants across the
  whole width; no Description (More options has it); Cancel and Create as the standard secondary and primary buttons.
-->
<div class="form">
  <div class="heading">
    <div class="title">Add Event</div>
    <app-button2 appearance="secondary-ghost" size="s" ariaLabel="Close" (click)="handleClose()">
      <app-icon name="sapphire-close" />
    </app-button2>
  </div>

  <app-input
    appearance="sapphire-outline"
    ariaLabel="Event title"
    [inputFormControl]="form.controls.title"
    placeholder="Add Event Title"
    [withErrors]="submitted"
    [withClear]="true"
    [focusImmediately]="true"
    size="s"
  />

  <app-date-range-picker
    [fromDate]="form.controls.startDate"
    [toDate]="form.controls.endDate"
    [fromTime]="form.controls.startTime"
    [toTime]="form.controls.endTime"
    [allDay]="form.controls.allDay.value"
    [datesRequired]="true"
    [autoAdjustEnd]="true"
  />

  <div class="row">
    <app-checkbox [inputFormControl]="form.controls.allDay" title="All Day" appearance="sapphire" size="s" />

    <app-timezone-input
      class="min-w-0"
      [control]="form.controls.timeZone"
      placeholder="Select Time Zone"
      appearance="sapphire"
      buttonSize="m"
      leadingIcon="sapphire-globe"
      [caption]="tzSeeder.caption()"
    />
  </div>

  <app-checkbox [inputFormControl]="form.controls.reminder" [title]="reminderLabel()" appearance="sapphire" size="s" />

  <div class="pair">
    <div class="field">
      <span class="field-label">Repeat</span>
      <app-recurrence-picker
        appearance="sapphire-outline"
        [control]="form.controls.recurrence"
        [referenceDate]="form.controls.startDate"
        [allDay]="form.controls.allDay"
        [timeZone]="form.controls.timeZone"
        size="m"
      />
    </div>

    <div class="field">
      <span class="field-label">Calendar</span>
      <app-autocomplete-input
        appearance="sapphire-outline"
        [suggestions]="calendarSuggestions"
        [inputFormControl]="form.controls.calendarId"
        size="s"
      />
    </div>
  </div>

  @if (needsNewCalendar && newCalendarStatus() !== 'ready') {
    <div class="row" role="status">
      @switch (newCalendarStatus()) {
        @case ('loading') {
          Loading calendars for this workspace.
        }
        @case ('empty') {
          This workspace has no calendar available for new events. Create a calendar before saving this event.
        }
        @case ('error') {
          Could not load calendars for this workspace. Reopen this form to try again.
        }
      }
    </div>
  }

  <div class="field">
    <span class="field-label">Meeting link</span>
    <app-input
      appearance="sapphire-outline"
      ariaLabel="Meeting link"
      placeholder="Add a meeting link"
      leadingIcon="sapphire-video"
      [inputFormControl]="form.controls.meetingLink"
      [withErrors]="submitted"
      [withClear]="true"
      size="s"
    />
  </div>

  <app-participants-input
    class="participants"
    [tenantItems]="event?.accountId ? [event] : undefined"
    [control]="form.controls.participants"
    [readonlyMode]="!!event?.isRemoteEvent"
  />

  <div class="footer">
    <app-button2 appearance="secondary-ghost" size="m" (click)="handleMore()">More options</app-button2>

    <div class="separator"></div>

    <app-button2 appearance="secondary" size="m" (click)="handleClose()">Cancel</app-button2>

    <app-button2
      appearance="primary"
      size="m"
      [disabled]="saveInProgress || (needsNewCalendar && newCalendarStatus() !== 'ready')"
      (click)="handleSubmit()"
    >
      Create
    </app-button2>
  </div>
</div>
